<template>
  <div class="body" >
    <div class="overlay"></div>
    <aside class="sidebar" :class="{ active: menuStatus }">
      <div class="close" @click="closeSidebar">
        <i class="fas fa-times"></i>
      </div>
      <router-link :to="{ name: 'Inicio' }" class="link-logo"
        ><img src="../assets/img/logoblanco.png" class="logo" alt=""
      /></router-link>
      <div class="navigation-container">
        <nav class="navigation">
          <ul class="navigation-ul">
            <router-link @click="closeSidebar" :to="{ name: 'Inicio' }" class="link"
              ><li class="navigation-li">
                <i class="fas fa-home"></i>Inicio
              </li></router-link
            >
            <router-link  @click="closeSidebar" :to="{ name: 'Sobre' }" class="link"
              ><li class="navigation-li">
                <i class="fas fa-user"></i>Sobre
              </li></router-link
            >
            <router-link @click="closeSidebar" :to="{ name: 'Servicios' }" class="link"
              ><li class="navigation-li">
                <i class="fas fa-list"></i>Servicios
              </li></router-link
            >
            <router-link @click="closeSidebar" :to="{ name: 'Portafolio' }" class="link"
              ><li class="navigation-li">
                <i class="fas fa-briefcase"></i>Portafolio
              </li></router-link
            >
            <router-link @click="closeSidebar" :to="{ name: 'Contacto' }" class="link"
              ><li class="navigation-li">
                <i class="fas fa-comments"></i>Contacto
              </li></router-link
            >
          </ul>
        </nav>
      </div>

      <div class="footer">
        <nav class="social-networks">
          <ul>
            <li></li>
          </ul>
        </nav>
        <div class="social-networks">
          <a href="https://github.com/amilcarex" target="_blank" class="social-networks__a"><i class="fa fa-github social-networks__i" aria-hidden="true"></i></a>
        </div>
        <div class="copyright">Copyright<span class="year"></span></div>
      </div>
    </aside>
    <div class="overlay" :class="{ active: menuStatus }"></div>
    <div class="menu">
      <router-link :to="{ name: 'Inicio' }" class="menu-logo"
        ><img src="../assets/img/logoblanco.png" alt=""
      /></router-link>
      <div class="home-menu" @click="showSidebar">
        <span class="home-menu__bar"></span>
      </div>
    </div>
    <div class="content padding-left max-width">
      <router-view v-slot="{ Component }">
        <FadeInOut entry="center" exit="center" :duration="300" mode="out-in">
          <component :is="Component" />
        </FadeInOut>
      </router-view>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { FadeInOut } from "vue3-transitions";
export default defineComponent({
  name: "layout-view",
  components: { FadeInOut },
  data() {
    return {
      menuStatus: false,
    };
  },
  methods: {
    showSidebar() {
      
      const body = document.querySelector('body');
      if (!this.menuStatus) {
        this.menuStatus = true;
        body.classList.add('overflow');
        return;
      }
      body.classList.remove('overflow');
      this.menuStatus = false;
    },

    closeSidebar() {
      const body = document.querySelector('body');
      if (this.menuStatus) {
        this.menuStatus = false;
        body.classList.remove('overflow');
      }
    },
  },
});
</script>

<style>
</style>